<template>
  <v-dialog
    :value="dialogs.popTwoFactor"
    :transition="false"
    width="1200"
    @click:outside="closeDialog"
    @keydown.esc="closeDialog"
  >
    <v-card>
      <v-card-text>
        <two-factor-enable-content is-popup />
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from "vuex";
import TwoFactorEnableContent from "./TwoFactorEnableContent";

export default {
  components: {
    TwoFactorEnableContent
  },
  data () {
    return {
      loading: false
    }
  },

  computed: {
    ...mapGetters({
      dialogs: 'main/dialogs',
    }),
  },

  methods: {
    closeDialog () {
      this.$store.dispatch('main/closeDialog', 'popTwoFactor')
    },
  }
}
</script>
